export default class ProofClient {
  constructor({ url, _get }) {
    this.url = url
    this.get = _get
  }

  async getByAccountAndDropId(account, dropId) {
    const url = `${this.url}/api/v1/user/${account}/proof/${dropId}`
    return this.get(url, {}, {proof: []})
  }
}
